<template>
  <div class="bfcm-offer-banner-cart">
    <span class="bfcm-sale-text"></span>
    <span class="bfcm-countdown"></span>
  </div>
</template>
